import React, {useState, useEffect} from 'react'
import '../css/home.css';
import { Link } from 'react-router-dom';
import {TronLinkAdapter} from '@tronweb3/tronwallet-adapter-tronlink';

const Finalise = () => {
  const [connected, setConnected] = useState(false);
  const [address, setAddress] = useState('');
  const [shortAddress, setShortAddress] = useState('');

    async function connect() {
      const adapter = new TronLinkAdapter();
      await adapter.connect();
      console.log("Connected to TronLink!");
      setConnected(true);
      setAddress(adapter.address);
    }

    useEffect(() => {
        setShortAddress(address.slice(0, 6) + "..." + address.slice(-6));
    }, [address]);
    
  return (
    <div>
        <div className='navbar'>
            <img src='https://i.ibb.co/ZVXyHrj/Screenshot-2023-10-02-183910.png' />
            <div className='button navbar-right' onClick={connect}>{connected ? shortAddress : 'Connect'}</div>
        </div>
        <div className='home-app'>
          <div className='top-heading'>{shortAddress ? `${shortAddress} Tron Metaverse Human` : 'Connect'}</div>
          <div className='big-box'>
            <div className='box-head'>Congratulations!</div>
            <div className='box-p'>Your metaverse human is under creation and it does take some time. You can come back later to view the generated result. After the result had successfully produced, you can download your Tron Metaverse Human 3D files here.
            Best part is, you can mint your Tron Metaverse Human into an NFT passport and have fun playing with it in a demo game scene we provided. See how you become a game character in the Tron Metaverse!</div>
          </div>
          <div className='button'>Mint Your 3d Figure</div>
        </div>
    </div>
  )
}

export default Finalise
